export default "__VITE_ASSET__DSZfApWk__"